import React from 'react'
import './footer.css'
import SocialMedia from '../SocialMedia/SocialMedia';


function Footer() {
  return (
    <div className='footer'>
      <SocialMedia/>
    </div>
  )
}

export default Footer